import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios'
import querystring from 'querystring'
import Storage from 'storejs'
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    //公众号appid
    //app_id:'wxc831f0e0ff8739c7',
    api_user: 'kycomp',
    api_password: 'sdf234$@E@EweDF',
    app_id:'wx3b36f5b587646918',
    open_id: '',//用户openid
    interObj:'',//页面定时器（当前页面定时器变量）
    isGeting:false,
    sso: {
      client_id:'57de371e63894f29aa073ddb55f28373',
      client_secret:'c71496ba18c346f8a5139176cd98f0e7',
      grant_type:'client_credentials',
      scope:'read',
      redirect:'https://www.bsapp.net',
      access_token: '',
    },
    upmsUser: '',
    userPermissions: []
  },
  actions: {
    // 检测token
    checkTokens (context, {ele,success,fail}) {
      console && console.log('检测token', Storage.get('sso'));
      // 是否有token
      if (!Storage.get('sso') || Storage.get('sso') == '' || !Storage.get('sso').access_token || Storage.get('sso').access_token == '') {
        console && console.log('未获取到access_token');
        context.commit('INIT_SSO');
        if(ele.$btools.check.isFunction(fail)){
          fail();
        }
      } else {
        console && console.log('获取到access_token');
        // 检验token
        axios.get(ele.$initUrl.api_url + '/upms').then((response) => {
          if (response.data.code == '200') {
            console && console.log('access_token正确');
            if(ele.$btools.check.isFunction(success)){
              success();
            }
          } else {
            context.commit('INIT_SSO');
            if(ele.$btools.check.isFunction(fail)){
              fail();
            }
          }
        }).catch(function (error) {
          console && console.log('检测Toker ERROR：', error);
          context.commit('INIT_SSO');
          if(ele.$btools.check.isFunction(fail)){
            fail();
          }
        })
      }
    },
    // 获取token
    getTokens(context,{ele,success,fail}){
      let _sso = this.state.sso;
      //+ele.$initUrl.token_url
      ele.$http.post(ele.$initUrl.token_url,querystring.stringify(ele.$btools.fuc.simplify(_sso))).then((response)=>{
        console && console.log('getTokens', response.data);
        context.commit('SET_TOKEN',response.data);
        if(ele.$btools.check.isFunction(success)){
          success();
        }
      }).catch((err)=>{
        console && console.log('获取token错误：', err);
        if (ele.$btools.check.isFunction(fail)) {
          fail(err)
        }
      });
    },
    // 获取用户信息
    getUpmsUser (context, {ele, success, fail}) {
      //微信openid
      let openid = Storage.get('openid');
      if(openid == 'undefined' || !openid){
        fail(false);
        return;
      }
      //xjjc_user
      axios.get(ele.$initUrl.api_url + '/xjjc_user?wxOpenId='+openid).then((response) => {
        console && console.log('getUpmsUser', response.data)
        store.dispatch("getUpmsRole",Vue.prototype);
        if(response.data.data.length==0){
          success('');
        }else {
          context.commit('SAVE_UPMS_USER', response.data.data.length === 1? response.data.data[0]:response.data.data.sort((a,b)=>{return  b.menu_item.length - a.menu_item.length})[0])
          if (ele.$btools.check.isFunction(success)) {
            success(response.data);
          }
        }
      }).catch(function (error) {
        console && console.log('获取UpmsUser错误：', error);
        if (ele.$btools.check.isFunction(fail)) {
          fail(error);
        }
      })
    },
    // 保存用户信息
    setUpmsUser(context,{ele,data,back}){
      context.commit('SAVE_UPMS_USER',data);
      if(ele.$btools.check.isFunction(back)){
        back();
      }
    },
    // 获取角色信息
    getUpmsRole(context,ele){
      axios.get(ele.$initUrl.api_url+'/xjjc_role').then((r)=>{
        console.log('成功获取角色信息：',r.data.data);
        context.commit('SAVE_UPMS_ROLE',r.data.data);
      }).catch((e)=>{
        console.log('获取角色信息失败：',e);
      });
    },
    // 发送权限申请
    sendApply(context,{ele,roleid,rolename,menus,success,fail}){
      let _user = Storage('upmsUser');
      let _sso = Storage.get('sso');
      axios({
        headers:{
          'Content-Type': 'application/json;charset=UTF-8'
        },
        method:'post',
        url:ele.$initUrl.api_url+'/xjjc_user_empower',
        data:JSON.stringify({accessToken:_sso.access_token,roleId:roleid,menuitemApply:menus,userId:_user.id,statusApply:0})
      }).then((response)=>{
        console.log('发送申请成功',response.data);
        ele.$storage.set('perInfo', {id:roleid,name:rolename})
        //跳转到主页（我的）界面
        if(ele.$btools.check.isFunction(success)){
          success();
        }
      }).catch(function(e){
        console.log('发送申请失败：',e);
        if(ele.$btools.check.isFunction(fail)){
          fail();
        }
      });
    },
    //设置定时器
    setInter(context,interID){
      context.commit('SET_INTER',interID);
    },
    //移除定时器
    removeInter(context){
      context.commit('SET_INTER',null);
    },
    setHttpState(context,state){
      context.commit('SET_HTTPSTATE',state);
    }
  },
  mutations: {
    // 保存sso
    SET_TOKEN (state, data) {
      let sso = state.sso
      sso.access_token = data.access_token
      //sso.refresh_token = data.refresh_token
      //sso.open_id = data.open_id
      //sso.token_type = data.token_type
      //sso.expires_in = data.expires_in

      state.sso = sso;
      Storage.set('sso', sso);
    },
    // 保存openid
    SET_OPENID(state,opid){
      let _opid = state.open_id
      _opid = opid;
      state.open_id = _opid;
      Storage.set('openid',_opid);
    },
    // 初始化sso
    INIT_SSO (state) {
      var initsso = {
        grant_type:state.sso.grant_type,
        client_id: state.sso.client_id,
        client_secret: state.sso.client_secret,
        redirect: state.sso.redirect,
        scope: state.sso.scope,
        access_token: '',
      }
      state.sso = initsso
      state.upmsUser = '';//用户
      state.userPermissions = [];//功能权限
      Storage.remove('sso')
      Storage.remove('upmsUser')
      Storage.remove('userPermissions')
    },
    // 保存权限信息（角色包含的功能）
    SAVE_UPMS_ROLE (state, data) {
      let tempdata = data.sort((a,b)=>{ return a.menuitem_role.length - b.menuitem_role.length})
      for (let i in tempdata){
        tempdata[i].role_level = i
      }
      Storage.set('roleDic',tempdata);
    },
    // 保存用户信息
    SAVE_UPMS_USER (state, data) {
      state.upmsUser = data//data.upmsUser
      // 菜单去重
      if(data.menu_item!=='暂无菜单'){
        const _menu = data.menu_item.split(',')
        const newData = Array.from(new Set(_menu))
        data.menu_item = newData.join(',')
      }
      Storage.set('upmsUser', data)//data.upmsUser)
    },
    // 设置定时器
    SET_INTER(state,data){
      state.interObj = data;
    },
    // 设置接口请求状态
    SET_HTTPSTATE(state,data){
      state.isGeting = data;
    }
  }
});
export default store;
